import React, { ImgHTMLAttributes, useState } from 'react';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import styles from './LazyImage.scss';

export const LazyImage: React.FunctionComponent<ImgHTMLAttributes<
  HTMLImageElement
>> = ({ alt = '', ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <span className={styles.wrapper}>
      {isLoading && (
        <PlaceholderBar
          height="100%"
          animated
          marginBottom="0"
          marginRight="0"
          marginTop="0"
          className={styles.skeleton}
        />
      )}

      <img
        alt={alt}
        onLoad={() => setIsLoading(false)}
        loading="lazy"
        {...rest}
      />
    </span>
  );
};
